import template from './picklist.template.html'

export default function() {
  return {
    template,
    restrict: 'E',
    replace: true,
    controllerAs: 'vm',
    controller: 'PicklistController',
    link: {
      post: function(scope, el) {},
    },
  }
}
